import React from 'react';
import { Form, CheckBox } from 'fw/forms';
import { Modal, Button } from 'react-bootstrap';

class ColumnSettingsModal extends React.Component {
	onClose = null;

	constructor(props) {
		super(props);
		this.state = {
			visible: false,
            pageKey: null,
			columns: [],
            validColumns: [],
            form: {}
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ visible: nextProps.visible });
	}

	open = (columns, pageKey, onSave, onClose) => {
        // Empty name cols won't be optional.
        const validCols = columns.filter(c => c.name !== "");

        // For every column, create a checkbox value, depending on the 'hidden' property.
        let form = {};

        validCols.forEach(c => {
            form[c.key] = !c.hidden;
        });

        // Save filtered columns, original columns and page key.
		this.setState({
            visible: true,
            pageKey: pageKey,
            columns: columns,
            validColumns: validCols,
            form: form
        }, () => {
			this.onClose = onClose;
			this.onSave = onSave;
		});
	}


	save = () => {
		this.setState({
			visible: false
		},  () => {
            // Clone state, update hidden values, and run callback
            let columns = [...this.state.columns];
            columns.forEach(c => c.hidden = !(this.state.form[c.key] === undefined ? true : this.state.form[c.key]));
            this.onSave && this.onSave(columns);

            // Save changes in local storage
            let columnSettings
            const oldSettings = localStorage.getItem("columnSettings");
            const storageData = columns.map(c => {
                return {
                    key: c.key,
                    hidden: c.hidden
                };
            });

            if (oldSettings) {
                columnSettings = JSON.parse(oldSettings);
                columnSettings[this.state.pageKey] = storageData;
            } else {
                columnSettings = {
                    [this.state.pageKey]: storageData
                };
            }

            localStorage.setItem("columnSettings", JSON.stringify(columnSettings));
		});
	}

	close = () => {
		this.setState({
			visible: false
		}, () => {
			this.onClose && this.onClose()
		});
	}

	handleChange = (form, callback) => {
		this.setState({ form }, callback);
	}

    renderCheckboxes() {
        const checkBoxes = this.state.validColumns.map(col => {
            return <CheckBox key={col.key} name={col.key} label={col.name} />
        });

        return (
            <div>
                {checkBoxes}
            </div>
        );
    }

	render() {
		return (
			<React.Fragment>
				<Modal show={this.state.visible} onHide={this.close} onEntered={this.focus}>
					<Form
                    values={this.state.form}
                    onChange={this.handleChange}
                    onSubmit={this.save}>
						<Modal.Header>
							<Modal.Title>Column configuration</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<p>Hide or show columns from the table by selecting or deselecting them:</p>
							{this.renderCheckboxes()}
						</Modal.Body>
						<Modal.Footer>
							<Button bsStyle="link" onClick={this.close}>Close</Button>
							<Button bsStyle="primary" type="submit">Save</Button>
						</Modal.Footer>
					</Form>
				</Modal>
			</React.Fragment>
		);
	}
}

export default ColumnSettingsModal;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/ColumnSettingsModal.js